import { ReactNode } from 'react';
import { Box, MuiTypographyProps, Tooltip, Typography } from 'ui';
import InfoSVG from 'ui/assets/icons/info';
import WarningSVG from 'ui/assets/icons/warning';
import { SxProps, Theme } from '@mui/material';
import { TypographyLink } from 'pages/endpoints/components/TypographyLink';

type Props = {
  label: string;
  labelColor?: MuiTypographyProps['color'];
  labelVariant?: MuiTypographyProps['variant'];
  info?: string;
  warningMessage?: NonNullable<ReactNode>;
  showWarningMessage?: boolean;
  actionButtonText?: string;
  onClickActionButton?: () => void;
  disableActionButton?: boolean;
  infoLabelStyle?: SxProps<Theme>;
  iconContainerStyle?: SxProps<Theme>;
};

export default function InfoLabel({
  label,
  labelColor = 'common.white',
  labelVariant = 'subtitle2',
  info,
  warningMessage,
  showWarningMessage,
  actionButtonText,
  onClickActionButton,
  disableActionButton,
  infoLabelStyle,
  iconContainerStyle
}: Props) {
  const handleActionClick = () => {
    !disableActionButton && onClickActionButton && onClickActionButton();
  };
  return (
    <Box display="flex" flexDirection={actionButtonText ? 'column' : 'row'} sx={infoLabelStyle}>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography variant={labelVariant} color={labelColor} mr={1}>
          {label}
        </Typography>
        {info && (
          <Tooltip title={info} arrow placement="top">
            <div>
              <Box sx={{ cursor: 'pointer', ...iconContainerStyle }}>
                <InfoSVG />
              </Box>
            </div>
          </Tooltip>
        )}
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        {actionButtonText && (
          <TypographyLink
            hasLink
            variant={onClickActionButton ? 'body3' : 'caption'}
            color={onClickActionButton ? 'primary.link' : 'grey.200'}
            sx={{ cursor: disableActionButton || !onClickActionButton ? 'default' : 'pointer' }}
            mr={1}
            onClick={handleActionClick}
          >
            {actionButtonText}
          </TypographyLink>
        )}
        {showWarningMessage && warningMessage && (
          <Tooltip maxWidth={333} title={warningMessage} arrow placement="top">
            <div>
              <Box ml={actionButtonText ? 0 : 1} display="flex" sx={{ cursor: 'pointer' }}>
                <WarningSVG />
              </Box>
            </div>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}
